import get from 'lodash/get'

interface ExportKey {
  label?: string
  key?: string
}

export interface ExportPlugin {
  csv(data: any[], keys: (string | ExportKey)[], title?: string): boolean
  download(blob: Blob, fileName: string): void
}

export default defineNuxtPlugin((nuxtApp) => {
  const plugin: ExportPlugin = {
    csv(data, keys, title) {
      let csv = keys.map(key => (key as ExportKey)?.label || key).join(',') + '\n'

      for (const item of data) {
        const object = item.toJSON()

        for (const key of keys) {
          let value = get(object, (key as ExportKey)?.key || (key as string))

          if (Array.isArray(value)) {
            value = value.join(', ')
          }

          csv += `"${value || ''}",`
        }

        csv += '\n'
      }

      const fileName = (title || 'export') + '.csv'
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })

      this.download(blob, fileName)

      return true
    },
    download(blob, fileName) {
      const link = document.createElement('a')
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob)

        link.setAttribute('href', url)
        link.setAttribute('download', fileName)

        link.style.visibility = 'hidden'

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },
  }

  nuxtApp.provide('export', plugin)
})
